module.exports = __webpack_public_path__ + "static/media/legalWarning.0bb5b162.pdf";